import React from 'react'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'

import { routes } from '_src/config'

import { parseArr, getRoutes } from '_src/utils/tool'

import App from './App'
import Admin from './admin'

import Login from '_src/pages/login/login'


class ERouter extends React.Component {

  render () {
    return (
      <HashRouter>
        <App>
          <Switch>
            <Route path="/login" component={Login} />
            <Admin>
              <Switch>
                {parseArr(getRoutes(routes)).map((item)=>(
                  <Route key = {item.path} path={item.path} exact={item.exact || false} component={item.component} />
                ))}
                <Redirect to="/home" />
              </Switch>
            </Admin>         
          </Switch>
        </App>
      </HashRouter>
    )
  }
}
export default ERouter